export default class SimulateurDeplacements extends HTMLElement {

    constructor() {
        super();
        this._autreCount = 0;
    }

    connectedCallback() {
        const btn = this.querySelector('[data-action="ajouter-deplacement"]');
        const container = this.querySelector('#autres-deplacements-container');
        const template = this.querySelector('#template-autre-deplacement');

        if (!btn || !container || !template) return;

        this._autreCount = parseInt(this.dataset.autresCount || '0', 10);

        btn.addEventListener('click', () => {
            const html = template.innerHTML.replaceAll('{INDEX}', this._autreCount);
            container.insertAdjacentHTML('beforeend', html);
            this._autreCount++;

            // Réinitialiser la validation jQuery Unobtrusive sur tout le formulaire
            // (parse(container) seul ne suffit pas quand le validateur est déjà actif)
            const form = container.closest('form');
            if (form && window.$ && $.validator && $.validator.unobtrusive) {
                $(form).removeData('validator').removeData('unobtrusiveValidation');
                $.validator.unobtrusive.parse(form);
            }
        });

        // Suppression d'un bloc "Autre déplacement"
        container.addEventListener('click', (e) => {
            const supprBtn = e.target.closest('[data-action="supprimer-deplacement"]');
            if (!supprBtn) return;
            supprBtn.closest('.rounded.border').remove();
        });
    }
}
